/**
 * Remove a previously-saved pending processing media entry once the
 * Firestore live listener reports isProcessing=false for it.
 *
 * Removal emits an eventBus event (via SecureStorageWebCrypto.remove)
 * that propagates to useListenToSecureStorageUpdatesByPrefix subscribers.
 */

import { SecureStorageWebCrypto } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';

export class ClearPendingProcessingMediaUseCase {
  constructor(private storage = SecureStorageWebCrypto.getInstance()) {}

  async execute(mediaId: string): Promise<void> {
    const key = SECURE_STORAGE_KEYS.PENDING_PROCESSING_MEDIA + mediaId;
    await this.storage.remove(key);
  }
}

export const clearPendingProcessingMediaUseCase = new ClearPendingProcessingMediaUseCase();
